<template>
    <div class="message">
        <div class="system">
            {{ message }}
        </div>
    </div>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>
<style scoped>
    .message{
        display: flex;
        justify-content: center;
        align-items: center;
        padding:2rem 0rem;
    }

    .system{
        font-weight: bold;
        color:var(--heading-primary);
        font-size: 1.2rem;
    }

    @media(max-width: 768px){
        .system{
            font-size:1rem;
        }

         .message{
            padding:1.5rem 0.8rem;
            text-align: center;
        }
    }
    
</style>